// extracted by mini-css-extract-plugin
module.exports = {"con":"msg_con__YFgmV","msg":"msg_msg__3m4Kx","ico":"msg_ico__2kiTh","bz":"msg_bz__1CU6S","tex":"msg_tex__1Z7RO","err":"msg_err__3ooSY","close":"msg_close__3jE05"};